import React, { useRef } from 'react';
import { TableStyled } from 'components/AntdTableModal/styled';

/**
 * columns: is columns for table.
 * dataSource: is data for render table, type array, every object in dataSource NEED UNIQUE KEY.
 * rowSelection: render checkbox per row, selected record.
 * isLoading: render loading when API fetching.
 * expandable: row collapse, render columns expand
 * scroll: take value FALSE | UNDEFINED, with value === false, turn off scroll bar
 */
import { InboxOutlined } from '@ant-design/icons';
import { Empty } from 'antd';
import useMultiLanguageCompanyList from 'page/Application/ManageCompanyList/CompanyList/hook/useMultiLanguageCompanyList';

const AntdTableModal = ({
  columns,
  dataSource,
  rowSelection,
  isLoading,
  expandable,
  emptyText,
  onChange,
  height,
}) => {
  const { COMPANY_LIST_NO_DATA } = useMultiLanguageCompanyList();
  const tableRef = useRef();
  const CustomEmptyText = () => {
    return (
      <Empty
        image={<InboxOutlined />}
        imageStyle={{ fontSize: 80 }}
        description={null}
        style={{ fontSize: '16px' }}
      >
        {emptyText || COMPANY_LIST_NO_DATA}
      </Empty>
    );
  };
  return (
    <TableStyled
      style={{ height: dataSource?.length > 0 ? '' : height }}
      ref={tableRef}
      columns={columns}
      rowSelection={rowSelection}
      //edit size of modal box to match with design
      scroll={dataSource?.length > 8 ? { y: `calc(100dvh - 420px` } : 0}
      expandable={expandable}
      dataSource={dataSource}
      pagination={false}
      showSizeChanger={true}
      onChange={onChange}
      loading={isLoading}
      locale={{ emptyText: CustomEmptyText }}
    />
  );
};

export default AntdTableModal;
